import { api } from "@/api";
import COMMON_API from "@/api/common.js";

class API {
  static getAreaSuggestion() {
    return api.get(`/v1/usuarios/areasNegocio/suggest/`);
  }
  
  static getUserList(payload) {
    return api.get(`/v1/usuarios/`, { params: payload });
  }

  static getUserSuggestions() {
    return api.get(`/v1/usuarios/suggest/`);
  }

  static getUser(userId) {
    return api.get(`/v1/usuarios/${userId}/`);
  }

  static postUser(payload) {
    return api.post(`/v1/usuarios/`, payload);
  }

  static putUser({ userId, payload }) {
    return api.put(`/v1/usuarios/${userId}`, payload);
  }

  static getEconomicGroupSuggestions(payload) {
    return COMMON_API.getEconomicGroup(payload);
  }

  static getUserWallet(userId) {
    return api.get(`/v1/usuarios/${userId}/carteira/`);
  }

  static putUserWalletTransfer({ userId, payload }) {
    return api.put(`/v1/usuarios/${userId}/carteira/migrar/`, payload);
  }

  static getOfficeSuggestions(payload) {
    const param = `grupo_economico_ids=${payload.grupo_economico_ids.join(
      ","
    )}`;
    return api.get(`/v1/gruposeconomicos/escritorios/suggest/?${param}`);
  }

  static getTypeProfiles() {
    return api.get("/v1/usuarios/posicoes/suggest");
  }
}

export default API;
